import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('planejamento', 'linha-investimento');

const linhaIvestimentoActions = {
  atualizar: { method: 'PUT', url: `${basePath}` },
  linhasInvestimento: { method: 'GET', url: `${basePath}/linhas-investimento/{codigo}` },
  buscarPorOrcamento: { method: 'GET', url: `${basePath}/orcamento/{codigo}` },
  transferir: { method: 'PUT', url: `${basePath}/transferir/{object}` },
  saldoDisponivel: { method: 'GET', url: `${basePath}/{codigo}/saldo-planejado-disponivel?anoMesInicio={anoMesInicio}&anoMesFim={anoMesFim}` },
  buscarLinhaPorOrcamentos: { method: 'POST', url: `${basePath}/orcamento` },
};

export default resource => resource(`${basePath}`, {}, linhaIvestimentoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/linhas-investimento.js